import React, { useState, useEffect } from "react";
import Layout from "../../../components/Layout";
import WidgetTitle from "../../../components/_widgets/WidgetTitle";
import api from "../../../config/api";
import { useHistory, useParams } from "react-router-dom";
import avatar from "../../../assets/img/avatar.svg";
import CircleImage from "../../../components/Image/CircleImage";
import NavbarPreference from "./components/Navbar";

function SingleClient(props) {
  const history = useHistory();
  const { id } = useParams();
  // const [active, setActive] = useState("food");
  const [userId, setUserId] = useState(id);
  const [user, setUser] = useState({});
  const [categories, setCategories] = useState([]);
  const [categorySelected, setCategorySelected] = useState(() => categories[0]?._id);
  const [preferences, setPreferences] = useState([]);
  const [historic, setHistoric] = useState([]);
  const [historicSelected, setHistoricSelected] = useState(false);

  /* console.log(props.match.params.id); */

  const getClient = async () => {
    const response = await api.get(`/user/${id}`);
    setUser(() => response.data);
  };

  async function getCategory() {
    try {
      await api.get(`category`).then((resp) => {
        setCategories(resp.data.reverse());
      });
    } catch (e) {
      console.error("ERROR GET CATEGORY: ", e);
    }
  }

  async function getClientPreferences(id) {
    try {
      await api.get(`client-preferences-dashboard/?category=${id}&user=${userId}`).then((resp) => {
        setPreferences(resp.data);
      });
    } catch (e) {
      console.error("ERROR GET CATEGORY: ", e);
    }
  }

  async function getClientReservation() {
    await api.get(`clientReservationByClient/${userId}`).then((resp) => {
      setHistoric(resp.data);
    });
  }

  const preferenceSelected = async (id) => {
    if (id === "historic") {
      setHistoricSelected(true);
      setCategorySelected("historic");
      return getClientReservation();
    }
    setHistoricSelected(false);
    setCategorySelected(id);
    await getClientPreferences(id);
  };

  useEffect(() => {
    getClient();
    getCategory();
  }, []);

  useEffect(() => {
    preferenceSelected(categories[0]?._id);
  }, [categories]);

  const handleBack = () => {
    history.goBack();
  };

  const exportTable = async () => {
    await api
      .get(`/client-excel/${id}`, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Layout buttonClick={handleBack} defaultMenu={4} title={"Cliente"} link={""}>
        <div className="box-profile-client col-lg d-flex">
          <div className="profile-client row col-3 item d-flex">
            <div className="d-flex justify-content-center align-items-center">
              <CircleImage
                url={user.avatar !== undefined ? (user.avatar !== "" ? user.avatar : avatar) : avatar}
                sizePx={"124px"}
              />
            </div>
            {/* <img alt="" width={"100%"} src={user.avatar ? user.avatar : avatar} /> */}
            <h4 className=" ff-univanova-regular mb-0 text-cl-black ff-univanova-600 fz-20">{user.name}</h4>
            {/* <a className="ff-univanova-regular text-center" href="#">
              Baixar PDF
            </a> */}
            <a
              className="ff-univanova-regular text-center c-pointer"
              onClick={() => {
                exportTable();
              }}
            >
              Baixar planilha
            </a>
          </div>
          <div className="col-9 profile-client-single">
            <div className="client-child-single">
              <p className="ff-univanova-regular">Data de nascimento: {user.birthdate ? user.birthdate : "-"}</p>
              <p className="ff-univanova-regular">Telefone: {user.phone ? user.phone : "-"}</p>
            </div>
            <div className="client-child-single">
              <p className="ff-univanova-regular">E-mail: {user.email ? user.email : "-"}</p>
              <p className="ff-univanova-regular">CPF: {user.cpf ? user.cpf : "-"}</p>
            </div>
            <div className="client-child-single">
              <p className="ff-univanova-regular">RG: {user.rg ? user.rg : "-"}</p>
              <p className="ff-univanova-regular">RG único: {user.rgUnique ? user.rgUnique : "-"}</p>
            </div>
            <div className="client-last-child-single">
              <p className="ff-univanova-regular">
                {user.address?.length ? `Endereço: ${user?.address[0]?.address}` : "Endereço: -"}
              </p>
            </div>
          </div>
        </div>

        <WidgetTitle title={"Preferências do cliente"} />

        <div className="box-profile-client-navbar col-lg d-flex">
          <NavbarPreference
            categories={categories}
            appearance="subtle"
            active={categorySelected}
            onSelect={preferenceSelected}
          />
        </div>

        <div className="pb-50">
          <>
            {!historicSelected && preferences?.preferences?.length ? (
              <>
                {preferences.preferences.map((preference) => (
                  <div className="card-client col-lg d-flex">
                    <div>
                      <span>{preference.title}: </span>{" "}
                      <p className="ff-univanova-regular">{preference.description.join(", ") + "."}</p>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <></>
            )}
          </>
          <>
            {historicSelected && historic.length ? (
              <>
                {historic.map((reserve, index) => (
                  <div className={` card-client col-lg d-flex ${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}>
                    <div>
                      <p>{`Reservou em ${reserve.establishment.storeName} as ${
                        reserve.time ? reserve.time : "--:--"
                      } no dia ${new Date(reserve.date).toLocaleDateString("pt-BR")} ${
                        reserve.products.length >= 1 ? "os items:" : ""
                      } `}</p>
                      <p className=" d-flex ">
                        {reserve.products.length ? (
                          <>
                            {reserve.products.map((product) => (
                              <p className="ms-1">{product.productName}</p>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <></>
            )}
          </>
        </div>
      </Layout>
    </>
  );
}

export default SingleClient;
